import { render, staticRenderFns } from "./GaDriver.vue?vue&type=template&id=23831c5b&scoped=true"
import script from "./GaDriver.vue?vue&type=script&lang=js"
export * from "./GaDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23831c5b",
  null
  
)

export default component.exports